<div class="hw-box-content">
  <div class="hw-header-wrap">
      <div class="row">
          <div class="col-6">
              <i class="fn-global-site"></i>
              Alert History
          </div>
          <div class="col-6 text-right">
              <fn-button *ngIf="!showData" [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Move To Dashboard'"
                  (click)="backtoDashboard()"></fn-button>
          </div>
      </div>
  </div>
  <div class="hw-title">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top">
              <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
                [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
              </fn-date-range-picker>
            </li>
            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="inlineFormCheck">
                  Select Product
                </label>
              </div>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray" (changeEvent)="filterIdenNo()"
                [placeholder]="'Select Product'" [(ngModel)]="selectProduct" [ngModelOptions]="{standalone: true}">
              </fn-select>
            </li>
            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="findBy">Find by Id</label>
              </div>
            </li>
            <li class="align-top pt-7">
              <fn-switch [(ngModel)]="customFlag" [name]="'customFlag'"></fn-switch>
            </li>
          @if(!customFlag){
          <li class="align-top pt-7 width-100px">
            <div class="form-check">
              <label class="form-check-label" for="inlineFormCheck">
                Select IdenNo
              </label>
            </div>
          </li>
          <li class="align-top width-400px">
            <fn-select [labelKey]="'idenNo'" [inputKey]="'idenNo'" [optionList]="idenNoArray"
          [placeholder]="'Select idenNo'" [(ngModel)]="selectIdenNo" [ngModelOptions]="{standalone: true}">
        </fn-select>
          </li>
        }
        @if(customFlag){
          <li class="align-top pt-7 width-100px">
            <div class="form-check">
              <label class="form-check-label" for="inlineFormCheck">
                Unique Id</label>
            </div>
          </li>
          <li class="align-top width-210px">
            <fn-base-input name="Alert ID" [(ngModel)]="description" [dataKey]="'description'" [type]="'string'" [fnInputValidator]></fn-base-input>
          </li>
        }
        <li class="align-top pt">
            <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
              (click)="getHistData(selectIdenNo)"></fn-button>
          </li>
          @if(alertHistoryArray.length >0){
            <li class="align-top pt">
              <fn-button
                [type]="'success'"
                [btnClass]="'btn-sm btn-round'"
                [text]="'Download CSV'"
                (click)="downloadCsv()"
              ></fn-button>
            </li>
            }
        </ul>
      </div>
      </div>
  </div>
  <div class="hw-content">
    <div class="row">
        <div class="col-12" >
          @if (uiMap.isDataLoaded) {
              <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='alertHistoryArray' [pageSize]="15"> 
               <ng-template #customTempRef let-row>
                <i class="fn-global-information" style="margin-right: 10px;" title="Alert Help" (click)="helpDetails(row)"></i>
                <i class="fn-global-reports"  title="View Activity" (click)="infoRowAction(row)"></i>
              </ng-template>  
            </fn-table>  
          }
          </div>
    </div>
</div>
</div>